import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { baseUrl } from 'src/environments/environment';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    constructor(
        private authService: AuthService,
    ) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let headers;
        headers = {
            "cache-control": "no-cache",
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
        };
        if (this.authService.getCurrentUser()){
            headers = { 
                ...headers,
                'authorization': this.authService.getCurrentUser().token
            }
        }
        request = request.clone({
            url: baseUrl + request.url,
            setHeaders: headers
        });
        // console.log(request);
        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {}
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                // console.log(error.status);
                if (error.status === 401) {
                    this.authService.logout();
                }
                return throwError(error);
            })
        );
    }
}